﻿export interface IEmailModel {
    id: number;
    description: string;
}
